<template>
  <div class="row">

    <div class="col-12">
      <div class="toggle-btn-container cursor-pointer" @click.prevent="toggleShow">
        <h3 class="page-sub-title mt-3 mb-0">
          {{nameTitle}} {{title}}
          <span v-if="!isShowAll" class="float-right">{{'protocol.buttons.showAll' | trans}}</span>
          <span v-if="isShowAll" class="float-right">{{'protocol.buttons.hideAll' | trans}}</span>
        </h3>
      </div>
    </div>
    <div class="col-12">
        <slot v-if="isShowAll"></slot>
    </div>

  </div>

</template>

<script>
  import {mapGetters} from 'vuex';

  export default {

    props: {
      'title': null,
      'nameTitle': null
    },

    data() {
      return {
        isShowAll: false,
      };
    },

    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },

    methods: {

      toggleShow: function() {
        this.isShowAll = !this.isShowAll;
      },

    },

  };
</script>


// WEBPACK FOOTER //
// src/common/toggleViewList/components/ToggleView.vue